export default __webpack_public_path__ + "static/media/beJOE.af57c84d.png";